const clamp = (value, min, max) => {
  if (!value) {
    return min;
  }
  return Math.min(Math.max(min, value), max);
};

export default clamp;
